import { COLORS } from '@btime/constants'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import EditTemplateContentForm from './EditTemplateContentForm'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TemplateLoader from './_load/TemplateLoader'

const EditTemplateContentPage = ({ id }) => {
  return (
    <AbsolutePageTemplate bgColor={COLORS.light2}>
      <PermissionChecker module="template">
        <TemplateLoader id={id}>
          <EditTemplateContentForm />
          <Separator weight={40} />
        </TemplateLoader>
      </PermissionChecker>
    </AbsolutePageTemplate>
  )
}

export default EditTemplateContentPage
